var themeContract = {
  argos: {
    color: {
      primary: 'brand-3',
      secondary: 'brand-2'
    }
  },
  habitat: {
    color: {
      primary: 'brand-1',
      secondary: 'brand-2'
    }
  },
  tu: {
    color: {
      primary: 'brand-1',
      secondary: 'brand-2'
    }
  },
  nectar: {
    color: {
      primary: 'brand-2',
      secondary: 'brand-1'
    }
  },
  sainsburys: {
    color: {
      primary: 'brand-1',
      secondary: 'brand-1'
    }
  }
};
export { themeContract };